import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Self,
  ChangeDetectionStrategy
} from '@angular/core';
import { CustomConfigOption } from '../../../types';
import { UntypedFormControl, NgControl } from '@angular/forms';
import { AbstractValueAccessor } from '../../../../../core/form/FormControl';
import { filter, tap } from 'rxjs/operators';
import { translationProvider } from '@ui/nls/translations/translate.directive';

interface SingleOption {
  label: Array<{ language: string; text: string }>;
  description: Array<{ language: string; text: string }>;
  picked: boolean;
  paramId: string;
  icon: string;
}

@Component({
    selector: 'lib-product-param-picker',
    templateUrl: './product-param-picker.component.html',
    styleUrls: ['./product-param-picker.component.scss'],
    providers: [translationProvider('productFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductParamPickerComponent
  extends AbstractValueAccessor
  implements OnInit
{
  visibleOptions: Array<SingleOption> = [];
  mode: 'select' | 'buttons' = 'select';
  control = new UntypedFormControl();
  @HostBinding('class.iconMode') iconMode = false;

  @Input() set options(options: Array<CustomConfigOption>) {
    options = options.filter(({ active }) => active);
    this.mode = options.length > 8 ? 'select' : 'buttons';
    this.visibleOptions = options.map((options) => ({
      label: options.label,
      description: options.description,
      icon: options.icon,
      picked:
        this.visibleOptions.find(({ picked }) => picked)?.paramId ===
        options.configId,
      paramId: options.configId,
    }));
    this.iconMode = this.visibleOptions.filter(({ icon }) => icon).length > 0;
  }

  constructor(
    @Self() @Optional() public ngControl: NgControl,
    private cd: ChangeDetectorRef
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    let updateInProgress = false;
    this.subscribeWhileAlive(
      this.valueSubject.pipe(
        filter(() => !updateInProgress),
        tap((newValue) => {
          console.log(newValue);

          this.visibleOptions.forEach(({ paramId }, index, all) => {
            all[index].picked = paramId === newValue;
          });
          console.log(this.visibleOptions);
          updateInProgress = true;
          this.control.patchValue(newValue);
          updateInProgress = false;
          this.cd.detectChanges();
        })
      ),
      this.control.valueChanges.pipe(
        filter(() => !updateInProgress),
        tap((newValue) => {
          updateInProgress = true;
          this.writeValue(newValue);
          updateInProgress = false;
        })
      )
    );
  }

  resetOptions() {
    this.visibleOptions.forEach(
      (value, index1, array) => (array[index1].picked = false)
    );
  }

  pick(index) {
    console.log('pickewd');
    this.resetOptions();
    this.visibleOptions[index].picked = true;
    console.log(this.visibleOptions);
    this.writeValue(this.visibleOptions[index].paramId);
    this.cd.detectChanges();
  }

  trackOption(i, option: SingleOption) {
    return option.paramId;
  }
}
